import GlobalProperties from 'core/helpers/global/global-properties'

export default function (value) {
  const fnTrue = value.fn
  const fnFalse = value.inverse

  return GlobalProperties.editable ? fnTrue(this) : fnFalse(this)
}
